import { render } from "./DictationComparison.vue?vue&type=template&id=6bf73ca9&scoped=true"
import script from "./DictationComparison.vue?vue&type=script&lang=js"
export * from "./DictationComparison.vue?vue&type=script&lang=js"

import "./DictationComparison.vue?vue&type=style&index=0&id=6bf73ca9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf73ca9"]])

export default __exports__